import {
  InstatusPageStatus,
  type InstatusActiveMaintenance,
  type InstatusResponse,
} from "@/api/resources/instatus/types";
import { SYSTEM_COLORS } from "@/configs/colorScheme";
import { getDatePlusMinus } from "@/utils/dates";
import { getFirstArrayValue } from "@/utils/format";
import { sortArray } from "@/utils/sort";

export const getInstatusPageStatusColor = (status: InstatusPageStatus) => {
  switch (status) {
    case InstatusPageStatus.UP:
      return SYSTEM_COLORS.success;
    case InstatusPageStatus.HASISSUES:
      return SYSTEM_COLORS.warning;
    case InstatusPageStatus.UNDERMAINTENANCE:
      return SYSTEM_COLORS.error;
  }
};
export const getInstatusPageStatusColorLight = (status: InstatusPageStatus) => {
  switch (status) {
    case InstatusPageStatus.UP:
      return SYSTEM_COLORS.successLight;
    case InstatusPageStatus.HASISSUES:
      return SYSTEM_COLORS.warningLight;
    case InstatusPageStatus.UNDERMAINTENANCE:
      return SYSTEM_COLORS.errorLight;
  }
};

export const hasInstatusPageIssue = (status: InstatusPageStatus) => {
  switch (status) {
    case InstatusPageStatus.UP:
      return false;
    case InstatusPageStatus.HASISSUES:
      return true;
    case InstatusPageStatus.UNDERMAINTENANCE:
      return false;
  }
};

export const getLatestInstatusMaintenance = (status: InstatusResponse) => {
  if (!status.activeMaintenances || status.activeMaintenances.length <= 0) return null;
  return getFirstArrayValue(sortArray(status.activeMaintenances).asc("start"));
};

export const getLatestInstatusIncident = (status: InstatusResponse) => {
  if (!status.activeIncidents || status.activeIncidents.length <= 0) return null;
  return getFirstArrayValue(sortArray(status.activeIncidents).asc("started"));
};

export const getInstatusMaintenanceEndDate = (maintenance: InstatusActiveMaintenance) => {
  return getDatePlusMinus(maintenance.start, maintenance.duration, "minutes");
};
